import { CerebralError } from 'cerebral'

export class StateError extends CerebralError {}